import React from 'react';
import { FaQrcode } from 'react-icons/fa';

const Header = () => {
  return (
    <header className="relative z-10 w-full max-w-4xl mx-auto mb-8 text-center px-4">
      <div className="glass-card p-8 border-t-2 border-t-primary/50 relative overflow-hidden group">
        <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-primary to-transparent opacity-75"></div>
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="flex items-center justify-center gap-4">
            <div className="text-4xl text-primary animate-pulse">
              <FaQrcode aria-hidden="true" />
            </div>
            {/* 使用 h1 提升 SEO 權重 */}
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white via-primary-light to-white drop-shadow-lg">
              QR星球
            </h1>
          </div>
          <p className="text-slate-400 text-lg max-w-xl">
            最強大的免費 QR Code 生成工具，由 <span className="text-primary-light">Homy Tech</span> 專業驅動
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;